module.exports = function anonymous(it
) {
var out='<section class="instance-detail-container '+(it.containerClass || '')+'"> <div class="instance-container"> <div class="content js-recordm-instance"></div> </div></section>';return out;
}